import { PIXEL_STORAGE_KEYS } from '~/utils/constants'
import { customSetCookie } from '~/utils/deviceInfo'
export default {
    watch: {
        $route() {
            if (!this.$cookie.get('token')) {
                this.appendPixelQueryParams()
            }
        },
    },
    async mounted() {
        // Check if pixel id is existing, then initialize the pixel
        const queryPixelId = this.$route.query.px_id
        const queryBannerId = this.$route.query.banner_id
        const queryBannerAdType = this.$route.query.ad_type
        const queryPlayerType = this.$route.query?.player_type
        const fbclid = this.$route.query.fbclid
        const xClickId = this.$route.query?.click_id
        const referer = this.$route.query.referer
            ? decodeURIComponent(this.$route.query.referer)
            : ''

        if (queryPlayerType) {
            customSetCookie(`x-player-type`, queryPlayerType, 10)
        }
        if (xClickId) {
            customSetCookie('x-click-id', xClickId, 10)
        }

        if (fbclid && fbclid !== 'undefined') {
            localStorage.setItem('fbclid', fbclid)
        }
        if (referer) localStorage.setItem('referer', referer)
        if (referer) this.$cookie.set('x-banner-url', referer)

        // Remove pixel expiration time logic
        if (localStorage.getItem(PIXEL_STORAGE_KEYS.pixelExpiredStorage)) {
            try {
                // Check if today is greater than pixel expiration date, then remove all pixel data
                const today = new Date()
                const expiredDate = new Date(
                    localStorage.getItem(PIXEL_STORAGE_KEYS.pixelExpiredStorage)
                )
                if (today > expiredDate) {
                    localStorage.removeItem(PIXEL_STORAGE_KEYS.pixelId)
                    localStorage.removeItem(PIXEL_STORAGE_KEYS.bannerId)
                    localStorage.removeItem(PIXEL_STORAGE_KEYS.bannerAdType)
                }
            } catch (error) {}
        }

        if (queryPixelId && queryBannerId && queryBannerAdType) {
            const pixelExpirationDate = new Date()
            pixelExpirationDate.setDate(new Date().getDate() + 60)

            localStorage.setItem(PIXEL_STORAGE_KEYS.pixelId, queryPixelId)
            localStorage.setItem(PIXEL_STORAGE_KEYS.bannerId, queryBannerId)
            localStorage.setItem(
                PIXEL_STORAGE_KEYS.bannerAdType,
                queryBannerAdType
            )
            localStorage.setItem(
                PIXEL_STORAGE_KEYS.pixelExpiredStorage,
                pixelExpirationDate.toISOString()
            )
        }

        let pixelId =
            queryPixelId ||
            localStorage.getItem(PIXEL_STORAGE_KEYS.pixelId) ||
            this.$store.state.pixel.pixelId
        let bannerId =
            queryBannerId ||
            localStorage.getItem(PIXEL_STORAGE_KEYS.bannerId) ||
            this.$store.state.pixel.bannerId
        let bannerAdType =
            queryBannerAdType ||
            localStorage.getItem(PIXEL_STORAGE_KEYS.bannerAdType)

        if (pixelId) this.$store.commit('pixel/setPixelId', pixelId)
        if (bannerId) this.$store.commit('pixel/setBannerId', bannerId)

        // Check pixel banner status from API
        const response = await this.$store.dispatch(
            'pixel/getPixelBannerStatus',
            {
                xDirectBannerId: bannerId,
                xBannerPixelId: pixelId,
            }
        )
        if (!response || !response?.status) {
            return
        }

        if (response.pixel_id) pixelId = response.pixel_id
        if (response.banner_id) bannerId = response.banner_id
        if (response.ad_type) bannerAdType = response.ad_type
        const isLoggedIn = !!this.$cookie.get('token')

        if (isLoggedIn) {
            let player = this.$store.state.player.player
            if (!player?.id) {
                await this.$store.dispatch('player/profile')
                player = this.$store.state.player.player
            }
            if (
                !player?.is_pixel_player &&
                player?.banner_id === response.banner_id
            ) {
                this.initializePixel(pixelId, bannerId, bannerAdType)
            }
            if (
                player?.is_pixel_player &&
                player?.banner_id &&
                player?.reg_pixel_id &&
                localStorage.getItem('fbclid')
            ) {
                localStorage.setItem(
                    PIXEL_STORAGE_KEYS.pixelId,
                    player.reg_pixel_id
                )
                localStorage.setItem(
                    PIXEL_STORAGE_KEYS.bannerId,
                    player.banner_id
                )
                this.$store.commit('pixel/setPixelId', player.reg_pixel_id)
                this.$store.commit('pixel/setBannerId', player.banner_id)
                this.initializePixel(
                    player.reg_pixel_id,
                    player.banner_id,
                    bannerAdType
                )
            }
            return
        }

        // not logged in yet → init pixel normally
        this.initializePixel(pixelId, bannerId, bannerAdType)
        this.appendPixelQueryParams()
    },
    methods: {
        appendPixelQueryParams() {
            const pixelId = localStorage.getItem(PIXEL_STORAGE_KEYS.pixelId)
            const bannerId = localStorage.getItem(PIXEL_STORAGE_KEYS.bannerId)
            const bannerAdType = localStorage.getItem(
                PIXEL_STORAGE_KEYS.bannerAdType
            )
            const fbclid = localStorage.getItem('fbclid')
            const playerType = this.$cookie.get('x-player-type')
            const clickId = this.$cookie.get('x-click-id')
            const referer = this.$cookie.get('x-banner-url')

            const extra = {}
            if (pixelId && !this.$route.query.px_id) extra.px_id = pixelId
            if (bannerId && !this.$route.query.banner_id)
                extra.banner_id = bannerId
            if (bannerAdType && !this.$route.query.ad_type)
                extra.ad_type = bannerAdType
            if (fbclid && !this.$route.query.fbclid) extra.fbclid = fbclid
            if (playerType && !this.$route.query.player_type)
                extra.player_type = playerType
            if (clickId && !this.$route.query.click_id) extra.click_id = clickId
            if (referer && !this.$route.query.referer)
                extra.referer = encodeURIComponent(referer)

            if (Object.keys(extra).length > 0) {
                this.$router
                    .replace({
                        query: { ...this.$route.query, ...extra },
                    })
                    .catch(() => {})
            }
        },
        initializePixel(pixelId, bannerId, bannerAdType) {
            const openCount = localStorage.getItem('open_count')
            // For PWA only, except store page
            if (this.isPwaStandalone() || this.$route.path === '/banners/pwa') {
                if (
                    pixelId &&
                    bannerId &&
                    parseFloat(bannerAdType || '') === 2
                ) {
                    this.$store.commit('pixel/setIsPwa', true)
                    this.$initFbPixel(pixelId)
                    // Init first view
                    if (!openCount && this.isPwaStandalone()) {
                        this.trackPixelEvent(this.PIXEL_EVENTS.firstView)
                        localStorage.setItem('open_count', '1')
                    }
                }
            }
            // For H5
            else if (
                pixelId &&
                bannerId &&
                parseFloat(bannerAdType || '') === 3
            ) {
                this.$store.commit('pixel/setIsH5', true)
                this.$initFbPixel(pixelId)
                // Init first view
                if (!openCount) {
                    this.trackPixelEvent(this.PIXEL_EVENTS.firstView)
                    localStorage.setItem('open_count', '1')
                }
            }
        },
    },
}
